import './Tabs.css';
export var tabsArrowButtonCSS = '_1y5sr6z6-2-0-1';
export var tabsArrowWrapperCSS = '_1y5sr6z5-2-0-1';
export var tabsCSS = '_1y5sr6z0-2-0-1';
export var tabsWrapperCSS = '_1y5sr6z1-2-0-1';
export var tabsWrapperOverflowCSS = {left:'_1y5sr6z2-2-0-1',right:'_1y5sr6z3-2-0-1',both:'_1y5sr6z4-2-0-1'};